import { useContext, useState } from 'react';
import { OrderContext } from '../context/OrderContext';

const useProductsSet = () => {

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const {apiClient, uuid, claimId, setMissingProduct, setShippingAdress} = useContext(OrderContext);


  const postProducts = async (ids) => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiClient.post(`api/v1/refund/${uuid}/set_products/`, {
        claim_id : claimId,
        order_product_ids : ids
      });
      const data = response.data;

      let claims_sessions=  sessionStorage.setItem('missingProducts', JSON.stringify(data.claims[0]));
      setMissingProduct(data.claims[0])

      let shippingAdress =  sessionStorage.setItem('shippingAdress', JSON.stringify(data.RelatedOrder.ShippingAddress));
      setShippingAdress(data.RelatedOrder.ShippingAddress)
     
    } catch (error) {
      const msg = error.response?.data?.error || error.message || 'API error';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return {postProducts};
};

export default useProductsSet;
